import type { Category, EventId, PlanEvent } from "../../../../shared/types";
import type {
  FormAnchor,
  PendingRecurrence,
  PendingResync,
} from "../../hooks/use-week-calendar-state";
import type { RecurrenceToastState } from "./RecurrenceActionToast";
import type {
  EventFullData,
  UpdateEventData,
} from "../../../events/types/event-form-types";
import { AddEventOverlay } from "./AddEventOverlay";
import { RecurrenceDialog } from "./RecurrenceDialog";

interface CalendarDialogsProps {
  readonly showAddForm: boolean;
  readonly showFullEditForm: boolean;
  readonly selectedDate?: string | null;
  readonly formStartTime: string | null;
  readonly formEndTime: string | null;
  readonly formAnchor: FormAnchor | null;
  readonly editingEvent: PlanEvent | null;
  readonly selectedEvents: PlanEvent[];
  readonly activeCategory: Category;
  readonly pendingRecurrence: PendingRecurrence | null;
  readonly pendingResync: PendingResync | null;
  readonly recurrenceToast: RecurrenceToastState | null;
  readonly onAddEvent: (
    title: string,
    category: Category,
    date: string,
    startTime: string,
    endTime: string,
  ) => void;
  readonly onAddEventFull?: (data: EventFullData) => void;
  readonly onUpdateEvent?: (id: EventId, updates: UpdateEventData) => void;
  readonly onCloseAddForm: () => void;
  readonly onSetShowFullEditForm: (v: boolean) => void;
  readonly onSetEditingEvent: (v: PlanEvent | null) => void;
  readonly onHandleRecurrenceChoice: (action: "this" | "all") => void;
  readonly onHandleResyncChoice: (action: "this" | "all") => void;
  readonly onSetPendingRecurrence: (v: PendingRecurrence | null) => void;
  readonly onSetPendingResync: (v: PendingResync | null) => void;
  readonly onSetRecurrenceToast: (v: RecurrenceToastState | null) => void;
}

export function CalendarDialogs({
  showAddForm,
  showFullEditForm,
  selectedDate,
  formStartTime,
  formEndTime,
  formAnchor,
  editingEvent,
  selectedEvents,
  activeCategory,
  pendingRecurrence,
  pendingResync,
  recurrenceToast,
  onAddEvent,
  onAddEventFull,
  onUpdateEvent,
  onCloseAddForm,
  onSetShowFullEditForm,
  onSetEditingEvent,
  onHandleRecurrenceChoice,
  onHandleResyncChoice,
  onSetPendingRecurrence,
  onSetPendingResync,
  onSetRecurrenceToast,
}: CalendarDialogsProps) {
  return (
    <>
      <AddEventOverlay
        showAddForm={showAddForm}
        showFullEditForm={showFullEditForm}
        selectedDate={selectedDate ?? null}
        formStartTime={formStartTime}
        formEndTime={formEndTime}
        formAnchor={formAnchor}
        editingEvent={editingEvent}
        selectedEvents={selectedEvents}
        activeCategory={activeCategory}
        onAddEvent={onAddEvent}
        onAddEventFull={onAddEventFull}
        onUpdateEvent={onUpdateEvent}
        onCloseAddForm={onCloseAddForm}
        onCloseEditForm={() => { onSetShowFullEditForm(false); onSetEditingEvent(null); }}
      />
      <RecurrenceDialog
        pendingRecurrence={pendingRecurrence}
        pendingResync={pendingResync}
        recurrenceToast={recurrenceToast}
        onRecurrenceChoice={onHandleRecurrenceChoice}
        onResyncChoice={onHandleResyncChoice}
        onClosePendingRecurrence={() => onSetPendingRecurrence(null)}
        onClosePendingResync={() => onSetPendingResync(null)}
        onDismissToast={() => onSetRecurrenceToast(null)}
      />
    </>
  );
}
